/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AiTriageConfig,
    AiTriageConfigFromJSON,
    AiTriageConfigFromJSONTyped,
    AiTriageConfigToJSON,
    FeedbackManagementConfig,
    FeedbackManagementConfigFromJSON,
    FeedbackManagementConfigFromJSONTyped,
    FeedbackManagementConfigToJSON,
    LockingConfig,
    LockingConfigFromJSON,
    LockingConfigFromJSONTyped,
    LockingConfigToJSON,
    SponsorsLabelingConfig,
    SponsorsLabelingConfigFromJSON,
    SponsorsLabelingConfigFromJSONTyped,
    SponsorsLabelingConfigToJSON,
    TriageConfig,
    TriageConfigFromJSON,
    TriageConfigFromJSONTyped,
    TriageConfigToJSON,
} from './';

/**
 * 
 * @export
 * @interface BaseConfig
 */
export interface BaseConfig {
    /**
     * 
     * @type {AiTriageConfig}
     * @memberof BaseConfig
     */
    aiTriage?: AiTriageConfig;
    /**
     * 
     * @type {TriageConfig}
     * @memberof BaseConfig
     */
    triage?: TriageConfig;
    /**
     * 
     * @type {LockingConfig}
     * @memberof BaseConfig
     */
    locking?: LockingConfig;
    /**
     * 
     * @type {FeedbackManagementConfig}
     * @memberof BaseConfig
     */
    feedbackManagement?: FeedbackManagementConfig;
    /**
     * 
     * @type {SponsorsLabelingConfig}
     * @memberof BaseConfig
     */
    sponsorsLabeling?: SponsorsLabelingConfig;
}

export function BaseConfigFromJSON(json: any): BaseConfig {
    return BaseConfigFromJSONTyped(json, false);
}

export function BaseConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aiTriage': !exists(json, 'aiTriage') ? undefined : AiTriageConfigFromJSON(json['aiTriage']),
        'triage': !exists(json, 'triage') ? undefined : TriageConfigFromJSON(json['triage']),
        'locking': !exists(json, 'locking') ? undefined : LockingConfigFromJSON(json['locking']),
        'feedbackManagement': !exists(json, 'feedbackManagement') ? undefined : FeedbackManagementConfigFromJSON(json['feedbackManagement']),
        'sponsorsLabeling': !exists(json, 'sponsorsLabeling') ? undefined : SponsorsLabelingConfigFromJSON(json['sponsorsLabeling']),
    };
}

export function BaseConfigToJSON(value?: BaseConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aiTriage': AiTriageConfigToJSON(value.aiTriage),
        'triage': TriageConfigToJSON(value.triage),
        'locking': LockingConfigToJSON(value.locking),
        'feedbackManagement': FeedbackManagementConfigToJSON(value.feedbackManagement),
        'sponsorsLabeling': SponsorsLabelingConfigToJSON(value.sponsorsLabeling),
    };
}

